import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './side/Sidebar';
import TopHeader from './side/TopHeader';
import ErrorPopup from './side/ErrorPopup';
import '../css/InquiryDetail.css';
import { SERVER_URL } from '../../config/config';
import '../css/InquiryAnswer.css';

const InquiryAnswer = () => {
  const { inquiryId } = useParams();
  const navigate = useNavigate();
  const [inquiry, setInquiry] = useState(null);
  const [answerTitle, setAnswerTitle] = useState('');
  const [answerContent, setAnswerContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isOriginalInquiryVisible, setIsOriginalInquiryVisible] = useState(true);

  useEffect(() => {
    fetchInquiryDetail();
  }, [inquiryId]);

  const fetchInquiryDetail = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/inquiry/${parseInt(inquiryId)}`, {
        params: {
          admin_id: localStorage.getItem('adminId')
        }
      });

      if (response.data.result_code === 200) {
        setInquiry(response.data.inquiry);
      }
    } catch (error) {
      setError('문의글을 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${SERVER_URL}/admin/inquiry/${inquiryId}/answer`, {
        admin_id: localStorage.getItem('adminId'),
        title: answerTitle,
        content: answerContent
      });

      if (response.data.result_code === 200) {
        setShowSuccessPopup(true);
      } else {
        setError('답변 등록에 실패했습니다.');
      }
    } catch (error) {
      setError('답변 등록에 실패했습니다.');
    }
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate(`/admin/inquiry`);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  const toggleOriginalInquiry = () => {
    setIsOriginalInquiryVisible(!isOriginalInquiryVisible);
  };

  if (loading) return <div className="loading">로딩 중...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!inquiry) return <div className="not-found">문의글을 찾을 수 없습니다.</div>;

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="detail-header">
            <button className="back-button" onClick={handleBack}>
              ← 목록으로
            </button>
            <h1>답변 작성</h1>
          </div>

          <div className="detail-content" id="answer-detail-conte" style={{ marginBottom: 1 }}>
            <div
              className="detail-row"
              style={{
                cursor: 'pointer',
                borderBottom: 'none',
                marginBottom: isOriginalInquiryVisible ? 20 : 0,
                paddingBottom: isOriginalInquiryVisible ? 20 : 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
              onClick={toggleOriginalInquiry}
            >
              <div className="detail-label">
                원본 문의
              </div>
              <button
                className="back-button"
                type="button"
                style={{
                  fontSize: 14,
                  padding: '4px 12px',
                  margin: 0,
                  background: '#f5f5f5',
                  color: '#222',
                  border: '1px solid #ddd'
                }}
              >
                {isOriginalInquiryVisible ? '숨기기 ▼' : '펼치기 ▶'}
              </button>
            </div>
            {isOriginalInquiryVisible && (
              <>
                <div className="detail-row">
                  <div className="detail-label">제목</div>
                  <div className="detail-value">{inquiry.title}</div>
                </div>
                <div className="detail-row">
                  <div className="detail-label">작성자</div>
                  <div className="detail-value">{inquiry.username}</div>
                </div>
                <div className="detail-row">
                  <div className="detail-label">작성일</div>
                  <div className="detail-value">{formatDate(inquiry.inquiry_date)}</div>
                </div>
                <div className="detail-row">
                  <div className="detail-label">내용</div>
                  <div className="detail-value content-text">{inquiry.content}</div>
                </div>
              </>
            )}
          </div>

          <form className="detail-content" onSubmit={handleSubmit}>
            <div className="detail-row">
              <div className="detail-label">답변 제목</div>
              <div className="detail-value">
                <input
                  type="text"
                  value={answerTitle}
                  onChange={(e) => setAnswerTitle(e.target.value)}
                  placeholder="답변 제목을 입력하세요"
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">답변 내용</div>
              <div className="detail-value">
                <textarea
                  value={answerContent}
                  onChange={(e) => setAnswerContent(e.target.value)}
                  placeholder="답변 내용을 입력하세요"
                  required
                  rows={8}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', resize: 'vertical' }}
                />
              </div>
            </div>
            <div className="inquiry-answer-button-group">
              <button type="submit" className="answer-button" style={{ position: 'absolute', right: '170px' }}>
                답변 등록
              </button>
              <button type="button" className="back-button" onClick={handleBack}>
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
      {showSuccessPopup && (
        <ErrorPopup
          message="답변이 성공적으로 등록되었습니다."
          onClose={handleSuccessPopupClose}
        />
      )}
    </div>
  );
};

export default InquiryAnswer;